var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 149.998,
    viewBox: "0 0 150 149.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41418",
    "data-name": "Group 41418",
    transform: "translate(-152.946 -210.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19867",
    "data-name": "Path 19867",
    d: "M302.946,286.09a75,75,0,1,1-74.632-75.143A74.992,74.992,0,0,1,302.946,286.09Zm-138.269-.263a63.268,63.268,0,1,0,63.457-63.151A63.278,63.278,0,0,0,164.677,285.827Z",
    transform: "translate(0 0)",
    fill: "#674188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19868",
    "data-name": "Path 19868",
    d: "M195.148,263.233c0,6.04.023,12.078-.007,18.118-.018,4.01-2.3,6.641-5.738,6.716-3.544.077-5.97-2.623-5.976-6.771q-.031-17.971,0-35.943c.007-3.984,2.33-6.662,5.736-6.743,3.5-.082,5.958,2.68,5.976,6.8C195.169,251.348,195.148,257.29,195.148,263.233Z",
    transform: "translate(38.661 35.103)",
    fill: "#674188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19869",
    "data-name": "Path 19869",
    d: "M190.647,228.5a7.9,7.9,0,1,1-8.118,7.79A7.848,7.848,0,0,1,190.647,228.5Z",
    transform: "translate(37.54 22.272)",
    fill: "#674188"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.4e2e2852b0683011070bc0542639801a.svg";
export { ForwardRef as ReactComponent };